/**
 * Created By Elia Rohana on 1/20/19
 */
import { initialState } from '../state';
import { BpmnProcessActions, BpmnProcessCreatorActionTypes } from '../actions';
import { BpmnDeploymentIdentifier } from '@ispm-shared/modules/bpmn';

export function bpmnIdentifier(state = initialState.bpmnIdentifier, action: BpmnProcessActions): BpmnDeploymentIdentifier {
  switch (action.type) {
    case BpmnProcessCreatorActionTypes.SET_BPMN_IDENTIFIER: {
      return { ...state, ...action.payload};
    }
    default: {
      return state;
    }
  }
}
